export default "__VITE_ASSET__DfGrdKiM__";